import { REQUIRED_MESSAGES } from '@srm/ui/lib/requiredMessage';
import { IRatingScaleProps } from './IRatingScaleProps';
import { IOption } from '@srm/ui/types/IOption';
import SelectControl from '@srm/ui/controls/SelectControl';
import { RatingScaleFrame } from './RatingScaleFrame';

interface IRatingScaleSelectProps extends IRatingScaleProps {
    scaleClassName: string;
    options: IOption[];
}

/** Шкала с баллом из фиксированного набора значений */
export const RatingScaleSelect = ({ scaleClassName, options, ...props }: IRatingScaleSelectProps) => {
    const { isEdit, methods } = props;

    return (
        <RatingScaleFrame {...props} scaleClassName={scaleClassName}>
            <SelectControl
                label="Балл"
                name="offerCrit.score"
                readOnly={true}
                required={true}
                rules={{ required: REQUIRED_MESSAGES.select }}
                disabled={!isEdit}
                highlightMenuItems={false}
                options={options}
                control={methods.control}
                setValue={(options) => {
                    return options[0].value;
                }}
                getValue={(options: IOption[], value: any) => {
                    return options.filter((x) => x.value === value);
                }}
            />
        </RatingScaleFrame>
    );
};
